import request from '../utils/request';

export function getRoomList(param) {
    return request({
        url: '/admin/search-room',
        method: 'GET',
        params: param
    })
}

export function saveRoom(id, data) {
    if (id === 0) {
        return request({
            url: '/admin/room',
            method: 'POST',
            data
        })
    }

    return request({
        url: '/admin/room/'+id,
        method: 'PUT',
        data
    })
}

export function deleteRoom(id) {
    return request({
        url: '/admin/room/'+id,
        method: 'DELETE'
    })
}

export function setRoomSort(id, sort) {
    return request({
        url: '/admin/room/'+id+'/sort/'+sort,
        method: 'PUT'
    })
}

export function setRoomIsvalidate(id, isvalidate) {
    return request({
        url: '/admin/room/'+id+'/is-validate/'+isvalidate,
        method: 'PUT'
    })
}

export function getRoomOption(id) {
	return request({
		url: '/admin/room-option?store_id='+id,
		method:'GET'
	})
}

export function getRoomDetail(id) {
    return request({
        url: '/admin/room-info/' + id,
        method: 'get'
    })
}
